export default {
  phone: /^1[3456789]\d{9}/,
  email: /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/,
  IDCard:
    /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  bankCard: /^([1-9]{1})(\d{14}|\d{18})$/,
}
